export const IoTManagementAdmin = {
  SaveHubSearchConfig: 'SaveHubSearchTemplate',
  EditLogFileContractNumbers: 'EditLogFileContractNumbers',
  ViewMultipleTwinUpdates: 'ViewMultipleTwinUpdates'
}

export const SoftwareDeployment = {
  DeviceSearchView: 'DeviceSearchView',
  DeploySoftwareView: 'DeploySoftwareView',
  DeploySoftwareDeploy: 'DeploySoftwareDeploy',
  DeploySoftwareApprove: 'DeploySoftwareApprove'
}

export const SoftwareManagement = {
  UploadSoftwareView: 'UploadSoftwareView',
  UploadSoftwareUpload: 'UploadSoftwareUpload',
  UploadSoftwareDelete: 'UploadSoftwareDelete',
  CreateDeploymentProfileView: 'CreateDeploymentProfileView',
  CreateDeploymentProfileCreate: 'CreateDeploymentProfileCreate',
  CreateDeploymentProfileEditDevice: 'CreateDeploymentProfileEditDevice',
  ProfileManagementView: 'ProfileManagementView',
  ProfileManagementDelete: 'ProfileManagementDelete',
  CreateMultipleTwinUpdate: 'CreateMultipleTwinUpdate',
  CreateLogRequest: 'CreateLogRequest',
  DisableDevice: 'DisableDevice',
}

export const UserManagement = {
  Create: 'AddUser',
  Edit: 'EditUser',
  Delete: 'DeleteUser'
}

export const DeviceTypeMgmt = {
  DeviceTypeAdd: 'AddDeviceType',
  DeviceTypeEdit: 'EditDeviceType',
  DeviceTypeView: 'ViewDeviceType'
}
